import Popup from 'components/popup/Popup'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import OopsMinion from 'assets/images/minions/OopsMinion.webp'
import CustomButton from 'components/custom-button/CustomButton'
import CustomImage from 'components/custom-image/CustomImage'
import { getClassNameForLanguage } from 'utils/common'

import './UnavailableFeaturePopup.scss'
import { PATH_BILLING } from 'config/paths'

interface IProps {
    isShow: boolean
    setIsShow: (show: boolean) => void
}

const UnavailableFeaturePopup = ({ isShow, setIsShow }: IProps) => {
    const { t, i18n } = useTranslation(['featuresPopup'])
    const history = useHistory()

    const topPart = (
        <div className='unavailable-feature-popup__image'>
            <CustomImage src={OopsMinion} />
        </div>
    )

    const bodyPart = (
        <div className='unavailable-feature-popup__body'>
            <div
                className={`unavailable-feature-popup__body-title
                    ${getClassNameForLanguage({
                        i18n,
                        uk: 'uk-bold',
                        eng: 'eng-bold',
                    })}`}
            >
                {t('featuresPopup:unavailable_popup:title')}
            </div>
            <div
                className={`unavailable-feature-popup__body-subtitle
                    ${getClassNameForLanguage({
                        i18n,
                        uk: 'uk-regular',
                        eng: 'eng-regular',
                    })}`}
            >
                {t('featuresPopup:unavailable_popup:subtitle')}
            </div>
        </div>
    )

    const buttons = [
        <CustomButton
            key='buttonCanel'
            handleClick={() => {
                setIsShow(false)
            }}
            design='cancel'
            size='small'
        >
            {t('featuresPopup:unavailable_popup:cancel')}
        </CustomButton>,
        <CustomButton
            key='buttonSubmit'
            handleClick={() => {
                history.push(PATH_BILLING.root)
                setIsShow(false)
            }}
            design='secondary'
            size='small'
        >
            {t('featuresPopup:unavailable_popup:upgrade')}
        </CustomButton>,
    ]

    return (
        <>
            <Popup
                showPopup={isShow}
                setShowPopup={setIsShow}
                topDesign='straight'
                topPart={topPart}
                bodyPart={bodyPart}
                buttons={buttons}
                additionalClass='unavailable-feature-popup'
            />
        </>
    )
}

export default UnavailableFeaturePopup
